import React from 'react'

import { ABO_LABEL } from 'shared/consts'
import { OFFER_TYPE_SAE } from 'shared/consts/marketplace'

import { shouldRenderLabel } from 'views/utils/redPointsUtils'
import { isMarketplace } from 'shared/experiments/utils'

export const shouldRenderProductLabels = ({ redPointsData, ...rest }) => {
  return (
    Object.values(rest)
      .concat(redPointsData && shouldRenderLabel(redPointsData))
      .filter(value => value === true || value?.length).length > 0
  )
}

/**
 * Helper adds a special style class for first <mobileLabelsInitialNumber> labels
 * that are not hidden with 'aria-hidden'. It has CSS rules that hide other labels
 * until the client script is loaded.
 * Client script removes the class and applies viewport size calculations,
 * so labels row is never overflowing the product card.
 *
 * @see app/views/assets/scripts/searchResultsHandlers.js#bindMobileLabels
 * @see app/views/components/organisms/FilteredProductList/SearchProductListItem/SearchProductListItem.scss
 */
export const decorateLabelsWithExtraMobileClasses = (
  labels,
  mobileLabelsInitialNumber
) => {
  let counter = mobileLabelsInitialNumber

  return React.Children.map(labels, label => {
    if (
      counter &&
      React.isValidElement(label) &&
      label.props['aria-hidden'] !== true &&
      label.props['aria-hidden'] !== 'true'
    ) {
      counter -= 1

      return React.cloneElement(label, {
        className: `${label.props.className} no-hide`
      })
    }

    return label
  })
}

export const isSaeOffer = ({ experiments, bestOffer }) => {
  return (
    !isMarketplace(experiments) ||
    bestOffer?.type === OFFER_TYPE_SAE ||
    bestOffer?.offerType === OFFER_TYPE_SAE
  )
}

export const shouldRenderAboLabel = ({ labels, offerTypeSae }) => {
  if (!labels.includes(ABO_LABEL)) {
    return false
  }

  return offerTypeSae
}
